import { OpenFeatureProvider } from '@openfeature/react-sdk'
import type { Router } from '@remix-run/router'
import type { IntlShape } from 'react-intl/src/types.js'
import { RouterProvider } from 'react-router-dom'

import type { InjectedAppProps } from '../../../server/types/server.types.js'
import { App } from '../../App.js'
import { FlagsProvider } from '../../featureFlags/FlagsProvider.js'

interface Props {
  i18n: IntlShape
  injectedAppProps: InjectedAppProps
  router: Router
}

export const ClientApp = ({ i18n, injectedAppProps, router }: Props) => {
  return (
    <OpenFeatureProvider>
      <FlagsProvider flags={injectedAppProps.flags}>
        <App i18n={i18n} injectedAppProps={injectedAppProps}>
          <RouterProvider router={router} />
        </App>
      </FlagsProvider>
    </OpenFeatureProvider>
  )
}
